import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left_triangle",
  "use": "icon-left_triangle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left_triangle\"><path d=\"M712.678 892.881L270.234 559.61c-30.745-23.159-30.745-73.365 0-96.528l442.444-333.266c28.497-21.467 64.145 5.387 64.145 48.329V844.61c0 42.884-35.643 69.747-64.145 48.271z\" fill=\"#e0620d\" p-id=\"151733\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol